// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestorBaseDto
 */
export interface IInvestorBaseDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    investor_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorBaseDto
     */
    status?: IInvestorBaseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    cash_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    equity_value?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    buy_pending_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorBaseDto
     */
    sell_pending_amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IInvestorBaseDtoStatusEnum {
    INVESTOR_CREATED = 'INVESTOR_CREATED',
    INVESTMENT_PATH_SELECTED = 'INVESTMENT_PATH_SELECTED',
    QUESTIONNAIRE_FILLED = 'QUESTIONNAIRE_FILLED',
    INVESTMENT_AMOUNT_SELECTED = 'INVESTMENT_AMOUNT_SELECTED',
    PENDING_EXTERNAL_CREATION = 'PENDING_EXTERNAL_CREATION',
    ACTIVE = 'ACTIVE'
}


/**
 * Check if a given object implements the IInvestorBaseDto interface.
 */
export function instanceOfIInvestorBaseDto(value: object): value is IInvestorBaseDto {
    return true;
}

export function IInvestorBaseDtoFromJSON(json: any): IInvestorBaseDto {
    return IInvestorBaseDtoFromJSONTyped(json, false);
}

export function IInvestorBaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestorBaseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'investor_id': json['investor_id'] == null ? undefined : json['investor_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'cash_balance': json['cash_balance'] == null ? undefined : json['cash_balance'],
        'equity_value': json['equity_value'] == null ? undefined : json['equity_value'],
        'buy_pending_amount': json['buy_pending_amount'] == null ? undefined : json['buy_pending_amount'],
        'sell_pending_amount': json['sell_pending_amount'] == null ? undefined : json['sell_pending_amount'],
    };
}

export function IInvestorBaseDtoToJSON(json: any): IInvestorBaseDto {
    return IInvestorBaseDtoToJSONTyped(json, false);
}

export function IInvestorBaseDtoToJSONTyped(value?: IInvestorBaseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'investor_id': value['investor_id'],
        'status': value['status'],
        'cash_balance': value['cash_balance'],
        'equity_value': value['equity_value'],
        'buy_pending_amount': value['buy_pending_amount'],
        'sell_pending_amount': value['sell_pending_amount'],
    };
}

